"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCertificateAlt(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M21.857 2.16c.59 0 1.094.21 1.514.63.42.42.629.924.629 1.513V19.42c0 .589-.21 1.093-.63 1.513-.42.42-.924.63-1.513.63H2.143c-.59 0-1.094-.21-1.514-.63C.21 20.513 0 20.01 0 19.42V4.303c0-.59.21-1.094.63-1.514.42-.42.924-.629 1.513-.629h19.714zm0 1.87H2.143a.412.412 0 00-.301.127.412.412 0 00-.128.302v14.96c0 .117.043.217.128.302a.412.412 0 00.3.127h19.715a.412.412 0 00.301-.127.412.412 0 00.128-.301V4.459a.412.412 0 00-.128-.302.412.412 0 00-.3-.127zm-5.44 13.448a1.43 1.43 0 01.158.2c.084-.03.162-.057.233-.08.34.574.1 1.133-.783 1.426-.37.185-.713.029-.83-.318-.11-.335.034-.71.398-.893.237-.102.45-.191.64-.265zm.158.2c-.242.087-.538.204-.88.353-.25.124-.346.375-.271.6.07.211.258.296.51.172.774-.258.94-.667.641-1.125zm.894-.37c.17.121.232.286.269.578l.008.07c.035.295.072.38.198.41.312.073.572.012 1.17-.22a4.37 4.37 0 01.637-.215l.054.234c-.164.038-.299.085-.604.204-.644.251-.935.32-1.312.23-.265-.063-.335-.223-.381-.615a8.55 8.55 0 00-.008-.068c-.03-.23-.072-.342-.17-.412-.04-.027-.177-.009-.402.057l-.12.037a1.485 1.485 0 00-.146-.206c.427-.14.687-.169.807-.084zm-7.65.125v1.09h-6v-1.09h6zm6.843-.04l-.119.04-.126.045c-.326-.343-.824-.555-1.054-.44-.507.254-.634.785-.424 1.158l-.21.117c-.273-.487-.11-1.172.527-1.49.365-.182 1.022.111 1.406.57zm.247-4.87v1.637H7.091v-1.636h9.818zM18 9.797v1.637H6.545V9.796H18zm-4.91-4.363v2.545L12 6.888l-1.09 1.09V5.433h2.18z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCertificateAlt;
exports.default = _default;